module.exports = __webpack_public_path__ + "static/media/saplogo.a182d1d7.png";